import { useEffect, useState } from 'react';
import { addSpaceBeforeUnit, isIrs6s3sCurve, isIrsBobCurve } from 'lib/constants';
import { socket, socketConnect, socketEmit } from '@/services/socket';

const HoverText = ({ irsData, irsId, isPageDashboard }) => {
    const [value, setValue] = useState(null);
    const isButterfly = !!irsData.end1Label && !!irsData.end2Label;
    const isSpread = !!irsData.end1Label && !isButterfly;
    const isCustomDate = (label) => label.split('/').length === 3;
    const key = `${irsId}_${irsData.startLabel}_${irsData.end1Label}_${irsData.end2Label}_${irsData.endLabel}`;

    const getAlignment = () => {
        if (isPageDashboard) {
            let text = 'left-[58%]';
            if (isButterfly) text = 'left-[90%]';
            if (isSpread) text = 'left-[75%]';
            if (isCustomDate(irsData.endLabel) || isCustomDate(irsData.startLabel)) text = 'left-[75%]';
            return text;
        }
        return 'left-[100%]';
    };

    const fetchIrsPrice = (data) => {
        if (data.reqId !== key) return;
        if (data.error) {
            setValue('N/A');
            return;
        }
        setValue(data.value);
    };

    useEffect(() => {
        socketConnect();

        socket.on('/get/irs-bonds/price', fetchIrsPrice);
        socketEmit('/get/irs-bonds/price', {
            irsId,
            startLabel: addSpaceBeforeUnit(irsData.startLabel),
            endLabel: addSpaceBeforeUnit(irsData.endLabel),
            end1Label: addSpaceBeforeUnit(irsData.end1Label),
            end2Label: addSpaceBeforeUnit(irsData.end2Label),
            reqId: key,
            start: irsData.start,
            type: irsData.type,
            end: irsData.end,
            immLabel: irsData.immLabel,
            start1: irsData.start1,
            end1: irsData.end1,
            ...(irsData.start1Label && ({ start1Label: addSpaceBeforeUnit(irsData.start1Label) })),
            ...((isIrsBobCurve(irsData?.type) || isIrs6s3sCurve(irsData?.type)) && ({ isBob6s3sCurve: true }))
        });

        return () => {
            socket.off('/get/irs-bonds/price', fetchIrsPrice);
        };
    }, []);

    return (
        <div className={`absolute top-1/2 ${getAlignment()} z-[999999] bg-gray-600 rounded px-2 py-1 !w-[104px] !h-[40px] font-medium text-white text-xs text-left`}>
            Indic Mid Price
            <p className='!text-warning-500'>{value} {(irsData.end1 || irsData.immLabel || isIrsBobCurve(irsData?.type) || isIrs6s3sCurve(irsData?.type)) ? 'bps' : '%'}</p>
        </div>
    );
};

export default HoverText;
